import React from 'react';
import { BaseColumn, StickyColWrapper } from './template.styles';
import { JRCColumnProps } from './template.type';

export function JRCColumn({ children, mode = 'center', position, ...props }: JRCColumnProps) {
    return (
        <BaseColumn $width={props?.width || 0} {...props} $position={position}>
            <StickyColWrapper $mode={mode} $position={position} className="dimension" $padding={props?.padding || ''}>
                {children}
            </StickyColWrapper>
        </BaseColumn>
    );
}
